import { createSlice } from "@reduxjs/toolkit";
import GetPayments from "../Actions/GetPayment-Action";

const initialState = {
  data: [],
  loading: false,
  status: "",
  lastEvaluatedkey: "",
  loadMore: false,
};

const Payments = createSlice({
  name: "Payments",
  initialState,
  reducers: {
    setShowSearch: (state, action) => {
      state.showSearch = action.payload; // Toggle or set the value of showSearch
    },
    setIsLoaded: (state, action) => {
      state.isLoaded = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetPayments.pending, (state) => {
        state.loading = true;
        state.status = "Loading...";
      })
      .addCase(GetPayments.fulfilled, (state, action) => {
        console.log("Action payload",action.payload,state.data);
        console.log("Last Evaluated Key in State:", state.lastEvaluatedkey);
        let currentArr = state.data; // Existing data
        let newArr = []; 
        newArr = action.payload.data;
        console.log("New Arr", newArr);
        state.data = currentArr.concat(newArr);
        console.log("New Data", state.data);
        state.lastEvaluatedkey = action.payload.lastEvaluatedKey || null;
        console.log(
          "Last Evaluated Key in Payload:",
          action.payload.lastEvaluatedKey
        );
        state.loadMore = false;
        state.loading = false;
        state.status = "Success";
      })
      .addCase(GetPayments.rejected, (state, action) => {
        state.loading = false;
        state.status = `Error: ${action.error.message}`;
      });
  },
});

// export default Payments.reducer;
export const PaymentAction = Payments.actions;
export default Payments.reducer;
